import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import isDesktop from "../isDesktop";
import RoleTabsSelect from "./RoleTabsSelect";

const UpdateRoleDialog = ({
  isOpen,
  onClose,
  onSave,
  onTabToggle,
  selectedTabs,
  tabs = [],
  tabsLoading = false,
}) => {
  const isDesktopDevice = isDesktop();

  console.log(selectedTabs, " selectedTabs inside UpdateRoleDialog");
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle style={{ fontWeight: "600" }}>Update Role</DialogTitle>
      <DialogContent style={{ width: !isDesktopDevice && "80vw" }}>
        <p
          style={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "14px",
            width: isDesktopDevice && "500px",
            height: "36px",
            boxShadow: "2px 2px 4px 0px #AEAEC080",
            background: "#EAF1F7",
            marginTop: "20px",
            marginBottom: "8px",
          }}
        >
          Tabs
        </p>
        <RoleTabsSelect
          selectedTabs={selectedTabs}
          tabs={tabs}
          tabsLoading={tabsLoading}
          onTabToggle={onTabToggle}
        />
      </DialogContent>
      <DialogActions style={{ margin: "auto", padding: "18px" }}>
        <Button
          onClick={onClose}
          style={{
            width: isDesktopDevice && "15vw",
            minWidth: !isDesktopDevice && "32vw",
            border: "2px solid #37446F",
            background: "none",
            height: isDesktopDevice ? "2.564vw" : "2.25rem",
            color: "black",
            textTransform: "none",
            marginRight: "10px",
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onSave}
          style={{
            width: isDesktopDevice && "15vw",
            minWidth: !isDesktopDevice && "32vw",
            background: "#37446F",
            height: isDesktopDevice ? "2.564vw" : "2.25rem",
            color: "white",
            textTransform: "none",
          }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateRoleDialog;
